module.exports = __webpack_public_path__ + "static/media/avatar.67752f96.png";